import { uniqWith } from 'ramda';

import { StandardColumnType } from '../../Queries/EkonomiskAnalysStandardColumnQuery/EkonomiskAnalysStandardColumnQuery';
import { ISuggestion } from '../../../../../../../../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import Logger from '../../../../../../../../../../../../../Utils/Logger';
import { EkonomiskAnalysBudgetQuery_db_EKBudget_All } from '../../Queries/EkonomiskAnalysBudgetQuery/_QueryTypes/EkonomiskAnalysBudgetQuery';

const standardColumnToSuggestion = (
  standardColumn: StandardColumnType
): ISuggestion => {
  let value;
  let name;

  if (standardColumn.FALTKOD == null) {
    Logger.error(
      new Error(
        'Tried to convert standard column with FALTKOD = null to suggestion'
      )
    );
    value = '';
  } else {
    value = standardColumn.FALTKOD;
  }

  if (standardColumn.BENAMNING == null) {
    Logger.error(
      new Error(
        'Tried to convert standard column with BENAMNING = null to suggestion'
      )
    );
    name = '';
  } else {
    name = standardColumn.BENAMNING;
  }

  return { value, name };
};

export const createStandardColumnSuggestions = (
  standardColumns: StandardColumnType[]
): ISuggestion[] => standardColumns.map(standardColumnToSuggestion);

const suggestionNameEqual = (
  suggestion1: ISuggestion,
  suggestion2: ISuggestion
) => suggestion1.name === suggestion2.name;

const specifikBudgetToSuggestion = (
  budget: EkonomiskAnalysBudgetQuery_db_EKBudget_All
): ISuggestion => {
  return { value: budget.NAMN, name: budget.NAMN };
};

const createSpecifikBudgetSuggestions = (
  budgetList: EkonomiskAnalysBudgetQuery_db_EKBudget_All[]
): ISuggestion[] =>
  uniqWith(suggestionNameEqual, budgetList.map(specifikBudgetToSuggestion));

const categoryBudgetToSuggestion = (
  budget: EkonomiskAnalysBudgetQuery_db_EKBudget_All
): ISuggestion => {
  let name = '';

  if (budget.BUDGETKATEGORI == null) {
    Logger.error(
      new Error(
        'Tried to convert budget with BUDGETKATEGORI = null to suggestion'
      )
    );
  } else {
    name = budget.BUDGETKATEGORI;
  }

  return { value: name, name };
};

const createCategoryBudgetSuggestions = (
  budgetList: EkonomiskAnalysBudgetQuery_db_EKBudget_All[]
): ISuggestion[] =>
  uniqWith(
    suggestionNameEqual,
    budgetList
      .filter(budget => budget.BUDGETKATEGORI)
      .map(categoryBudgetToSuggestion)
  );

export const createBudgetSuggestions = (
  isKategori: boolean,
  budgetList: EkonomiskAnalysBudgetQuery_db_EKBudget_All[]
): ISuggestion[] => {
  if (isKategori) {
    return createCategoryBudgetSuggestions(budgetList);
  } else {
    return createSpecifikBudgetSuggestions(budgetList);
  }
};
